import React, { useState } from "react";

// core components
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import AsynchronousAutocomplete from "../../../components/Autocomplete/AsynchronousAutocomplete";
import { Button, Collapse, GridLegacy } from "@mui/material";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import AddSalesAreasToOtherUserDialog from "../AddSalesAreasToOtherUserDialog";
import { useDialog } from "../../../licensing/utils/DialogProvider";

function Vestigingen() {
  const { control } = useFormContext();
  const [salesAreas, setSalesAreas] = useState(null);
  const [openDialog] = useDialog();

  const salesareaIds = useWatch({ name: "salesAreas" });
  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <GridLegacy container spacing={1}>
          <GridLegacy item xs={12}>
            <Controller
              control={control}
              defaultValue={""}
              name={"salesAreas"}
              render={({ field: { onChange, onBlur, value, name, ref }, fieldState: { error } }) => {
                return (
                  <AsynchronousAutocomplete
                    async={{
                      url: "core/vestigingen/search?fields=id as value, systeemNaam as label",
                      searchField: "systeemNaam",
                      perPage: 50,
                    }}
                    multiple={true}
                    onChange={(e, value) => {
                      setSalesAreas(value);
                      value = value.map((salesarea) => salesarea.value).join(",");
                      onChange({ target: { value: value } }, value);
                    }}
                    placeholder={getTranslation(
                      "gebruikers.form.vestigingen.taglist.menuFood.headerText",
                      "Select a sales area"
                    )}
                    value={
                      salesAreas ??
                      value
                        ?.split(",")
                        .filter((id) => id.length > 0)
                        .map((id) => ({ value: Number(id) }))
                    }
                  />
                );
              }}
            />
          </GridLegacy>
          <Collapse in={salesareaIds != null}>
            <GridLegacy item xs={12}>
              <Button
                color={"primary"}
                onClick={() => {
                  openDialog({
                    children: <AddSalesAreasToOtherUserDialog salesareaIds={salesareaIds} />,
                    fullWidth: true,
                  });
                }}
                variant={"outlined"}
              >
                <TranslationWrapper tKey={"Add sales areas to other user"} />
              </Button>
            </GridLegacy>
          </Collapse>
        </GridLegacy>
      </CardBody>
    </Card>
  );
}

export default Vestigingen;
